<template>
  <div class="app-container">
    <!-- 查询 -->
    <app-search>
      <div slot="content">
        <el-row :gutter="10" type="flex" justify="start" align="middle">
          <el-col :span="6">
            <el-form
              :label-position="'right'"
              :model="listQuery"
              :label-width="$t('carMonitor.monitorinfo.carStatus.search.width1') + 'px'"
            >
              <el-form-item :label="$t('public.licensePlate') + '：'">
                <el-input
                  v-model="listQuery.licensePlate"
                  filterable
                  clearable
                  :placeholder="$t('public.licensePlate')"
                />
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="6">
            <el-form
              :label-position="'right'"
              :model="listQuery"
              :label-width="$t('carMonitor.monitorinfo.carStatus.search.width2') + 'px'"
            >
              <el-form-item :label="$t('carMonitor.monitorinfo.carStatus.area') + '：'">
                <el-select
                  v-model="listQuery.areaId"
                  :placeholder="$t('carMonitor.monitorinfo.carStatus.area')"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="(item,index) in areaList"
                    :key="index"
                    :label="item.areaName"
                    :value="item.areaId"
                  />
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="6">
            <el-form
              :label-position="'right'"
              :model="listQuery"
              :label-width="$t('carMonitor.monitorinfo.carStatus.search.width3') + 'px'"
            >
              <el-form-item :label="$t('carMonitor.monitorinfo.carStatus.model') + '：'">
                <el-cascader
                  ref="cascader"
                  :placeholder="$t('carMonitor.monitorinfo.carStatus.model')"
                  v-model="listQuery.carSettings"
                  filterable
                  clearable
                  :options="modelList"
                  :props="props"
                  @change="handleChange"
                />
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <app-search-button
        slot="bottom"
        :is-collapse="false"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <!-- 按钮 -->
    <app-authorize-button
      :data="authouizeList"
      @click-add="addVisible=true"
      @click-filter="showfilter=true"
    >
      <checked-Filter
        slot="check-filter"
        :show.sync="showfilter"
        :list="tableList"
        :scroll-line="8"
      />
    </app-authorize-button>
    <!-- table -->
    <el-table
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      border
      fit
      highlight-current-row
      style="width: 100%"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      @sort-change="sortChange">
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item,index) in filterTableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :align="item.position"
        :width="item.width"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <div v-if="item.prop==='licensePlate'">
            <div>
            <vue-licenseplate
              :types="0"
              :licensepalte="scope.row[item.prop]"
              :area="scope.row['areaName']"
            />
            </div>
          </div>
          <div v-else-if="item.prop==='gpsPosition'">
            <span :class="scope.row['gpsPosition']===1 ? 'yesgps':'nogps'">
              <svg-icon
                icon-class="icon-gps"
              />
              {{ scope.row[item.prop] == 1 ? $t('public.other.yes') : $t('public.other.no') }}
            </span>
          </div>
          <div v-else-if="item.prop==='online'">
            <span  :class="scope.row[item.prop]===1 ? 'yesgps':'nogps'">
              <svg-icon
                :icon-class="scope.row[item.prop]===1 ? 'online-start':'online-end'"
              />
              {{ scope.row[item.prop] == 1 ? $t('public.other.yes') : $t('public.other.no') }}
            </span>
          </div>
          
          <div v-else>{{ scope.row[item.prop] ||  (scope.row[item.prop]===0?scope.row[item.prop]: '/') }}</div>
        </template>
      </el-table-column>
       <el-table-column :label="$t('carMonitor.terminalBatch.function')" align="center" width="100">
        <template slot-scope="scope">
          <el-tag @click="controlVisibles=true;tableRow=scope.row">
            {{ $t('public.setting') }}
          </el-tag>
          
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div :class="[total>0?'visible':'hidden','pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10,20,30,50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <controlDialog :data="tableRow" :visibles.sync="controlVisibles" />
  </div>
</template>

<script>
// 混入
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'

import controlDialog from './components/controlDialog.vue'
// request
import { getCarStatus } from "@/api/carMonitor/carStatus"
import { getArea, getModel } from "@/api/commont"

// 辅助函数
export default {
  name: 'terminalControl',
  components: { controlDialog },
  mixins: [pagingMixin, otherHeight, tableStyle],
  data() {
    return {
      listQuery: {
      },
      areaList: [],
      modelList: [],
      props: {
        label: "label",
        value: "id",
        children: "children",
        expandTrigger: "hover",
        // checkStrictly: true
      },

      showfilter: false,
      tableList: [
        {
          value: this.$t('public.licensePlate'),
          prop: "licensePlate",
          position: "center",
          width: '150',
          sortable: "custom",
          checked: true
        },
        {
          value: this.$t('public.obdCode'),
          prop: "barCode",
          position: "center",
          sortable: "custom",
          checked: true
        },
        {
          value: this.$t('public.mobile'),
          prop: "mobile",
          position: "center",
          sortable: "custom",
          checked: true
        },
        {
          value: this.$t('carMonitor.monitorinfo.carStatus.datasubmissiontime'),
          prop: "travelTime",
          position: "center",
          sortable: "custom",
          width: '190',
          checked: true
        },
        {
          value: this.$t('carMonitor.monitorinfo.carStatus.whetherterminalisonline'),
          prop: "online",
          position: "center",
          checked: true
        },
        {
          value: this.$t('carMonitor.monitorinfo.carStatus.GPSpositioning'),
          prop: "gpsPosition",
          position: "center",
          checked: true
        }
      ],
      authouizeList: [],
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false,
      controlVisibles: false,
      tableRow: {}
    }
  },
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    },
    lang() {
      return this.$store.getters.language
    }
  },
  created() {
    Promise.all([this._getArea(),this._getModel()])
  },
  methods: {
    // 加载数据
    listLoad() {
      this.listLoading = true
      // eslint-disable-next-line no-unused-vars
      const { carSettings, ...postData } = this.listQuery
      getCarStatus(postData).then(({ data }) => {
        this.list = []
        if (data.code === 0) {
          this.list = data.data || []
          this.total = data.total
          this.listLoading = false
        }
      }).catch(()=>{
        this.listLoading = false
      })
    },
    // 获取地区
    _getArea(){
      return getArea().then(({data})=>{
        if(data.code==0) {
          this.areaList = data.data || []
          return data.data
        }
      })
    },
    // 获取车型
    _getModel() {
      return getModel().then(({data})=>{
        if(data.code==0) {
          let result = []
          let resData = data.data || []
          this.transfromData(resData,result)
           this.modelList = result
          return result
        }
      })
    },
    // 转换树结构
    transfromData(data,result){
      data.forEach((item,index)=>{
        result.push({ 
          label: item.brandName || item.seriesName || item.modelName,
          id: item.brandId || item.seriesId || item.modelId, 
          code: item.brandCode || item.seriesCode || item.modelName
        })

        if((item.series && item.series.length) || (item.models&&item.models.length)){
          result[index].children = []
          this.transfromData(item.series || item.models,  result[index].children)
        }
      })
    },
    handleChange(val) {
      let arr = ["brand", "series", "model"]
      arr.forEach(item => {
        this.listQuery[item] = ""
      })
      for (let i = 0; i < arr.length; i++) {
        this.listQuery[arr[i]] = val[i]
      }
      this.$refs.cascader.panel.menus = [
        this.$refs.cascader.panel.store.getNodes()
      ]
      this.$refs.cascader.dropDownVisible = false
      // console.log(this.listQuery)
    },
  }
}
</script>

<style lang='scss' scoped>
.yesgps {
  color:  rgb(64, 109, 64);
}
.nogps {
  color: #98a3af
}
</style>
